import * as React from 'react';
import $ from "jquery";
import Common from '../utilities/common';
import { Alert, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, TextField } from '@mui/material';
import { NombrePila } from './NombrePila';
import ErrorDialog from '../utilities/ErrorDialog';

export interface INombrePilaEditProps {
    open: boolean;
    onClose?: Function;
    onSave?: Function;
    selectedItem: NombrePila | undefined;
}

export interface INombrePilaEditState {
    open: boolean;
    hasErrors: boolean;
    errorMessage: string;
    openErroDialog: boolean;
}

export default class NombrePilaEdit extends React.Component<INombrePilaEditProps, INombrePilaEditState> {
    _nombrePila: NombrePila = new NombrePila();
    _id: number = -1;
    
    public constructor(props: INombrePilaEditProps) {
        super(props);

        this.state = {
            open: false,
            hasErrors: false,
            errorMessage: '',
            openErroDialog: false
        }
    }

    componentWillReceiveProps(nextProps: Readonly<INombrePilaEditProps>, nextContext: any): void {
        if(nextProps.selectedItem != null) {
            this._nombrePila = nextProps.selectedItem;
        }

        this.setState({
            open: nextProps.open
        });
    }

    public render(): React.ReactElement<{}> {
        return (
            <React.Fragment>
                <Dialog open={this.state.open} fullWidth>
                    <DialogTitle>
                        Modificar nombre de pila
                    </DialogTitle>
                    <DialogContent>
                        {
                            this.state.hasErrors && (
                                <Alert severity="error" style={{marginBottom: '10px'}}>
                                    {
                                        this.state.errorMessage
                                    }
                                </Alert>
                            )
                        }
                        <Box>
                            <FormControl fullWidth style={{marginBottom: '20px'}}>
                                <TextField required variant='standard' label='Nombre' defaultValue={this._nombrePila.nombre} onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                    if(event.target.value == '') {
                                        this.setState(
                                            {
                                                hasErrors: true,
                                                errorMessage: 'Introduzca los valores correspondientes en los campos obligatorios o seleccione un archivo.'
                                            }
                                        );
                                    }
                                    else {
                                        this.setState(
                                            {
                                                hasErrors: false,
                                                errorMessage: ''
                                            }
                                        );
                                        this._nombrePila.nombre = event.target.value;
                                    }
                                }}></TextField>
                            </FormControl>
                            <FormControl fullWidth variant="standard">
                                <InputLabel id="labelComunidadAutonoma">Seleccione el sexo</InputLabel>
                                <Select label="Seleccione el sexo" defaultValue={this._nombrePila.sexo} labelId='labelComunidadAutonoma' onChange={(event: SelectChangeEvent) => {
                                    this._nombrePila.sexo = event.target.value;
                                }}>
                                    <MenuItem value={'M'}>Femenino</MenuItem>
                                    <MenuItem value={'H'}>Masculino</MenuItem>
                                </Select>
                            </FormControl>
                        </Box>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.Update.bind(this)}>OK</Button>
                        <Button onClick={this.Close.bind(this)}>Cancelar</Button>
                    </DialogActions>
                </Dialog>
                <ErrorDialog open={this.state.openErroDialog} onClose={this.Close.bind(this)} />
            </React.Fragment>
        )
    }

    private Close() {
        this.setState(
            {
                open: false,
                openErroDialog: false,
                hasErrors: false,
                errorMessage: ''
            }
        );

        if(this.props.onClose != null) {
            this.props.onClose();
        }
    }

    private Update() {
        if(this._nombrePila.nombre == '' || this._nombrePila.nombre == null) {
            this.setState({
                hasErrors: true,
                errorMessage: 'Introduzca los valores correspondientes en los campos obligatorios o seleccione un archivo.'
            })
            return;
        }

        let url = `${Common.END_POINT}/masters/nombrespila/${this._nombrePila.id}/update`;
        $.ajax((
            {
                url: url,
                type: "POST",
                data: JSON.stringify(this._nombrePila),
                dataType: "json",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done(() => {
            if(this.props.onSave != null) {
                this.props.onSave();
            }

            this._nombrePila = new NombrePila();
        }).fail((jqXHR, textStatus, errorThrown) => {
            this.setState(
                {
                    open: false,
                    openErroDialog: true
                }
            );
    
            if(this.props.onSave != null) {
                this.props.onSave();
            }

            this._nombrePila = new NombrePila();
        });
    }
}